import { createContext, ReactNode, useContext, useMemo } from 'react'

import { Variant } from '@web/gql/graphql'
import useAbTestTrack from '@web/hooks/useAbTestTrack'

interface AbTestEventContext {
  variant?: Variant
  targetClickCodes: string[]
}

const AbTestEventContext = createContext<AbTestEventContext | undefined>(undefined)

interface Props extends AbTestEventContext {
  children?: ReactNode
}

export const AbTestEventContextProvider = ({ variant, targetClickCodes, children }: Props) => {
  const content = useMemo<AbTestEventContext>(
    () => ({ variant, targetClickCodes }),
    [targetClickCodes, variant?.expId, variant?.name, variant?.sessionId],
  )

  return <AbTestEventContext.Provider value={content}>{children}</AbTestEventContext.Provider>
}

export const useAbTestNClick = () => {
  const { trackNClickEvent } = useAbTestTrack()
  const abtEvent = useContext(AbTestEventContext)

  return {
    trackNClickEvent: (_clickCode: string) => {
      if (!abtEvent?.variant) return

      const { variant, targetClickCodes } = abtEvent
      const abtClickCode = targetClickCodes.find(clickCode => _clickCode.includes(clickCode))

      if (!abtClickCode) return

      trackNClickEvent(variant, abtClickCode)
    },
  }
}
